import React from "react";
import "./receipt.css";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";

const BRAND = "#5bafd6";
const BRAND_RGB = [91, 175, 214];

const Receipt_B2C = () => {
  const [isDownloading, setIsDownloading] = React.useState(false);

  const [receiptData] = React.useState(() => {
    return JSON.parse(localStorage.getItem("receiptData"));
  });

  console.log("receiptData", receiptData);

  const allItems = [
    ...(receiptData?.investigtion_details || []),
    ...(receiptData?.package_details?.map((pkg) => ({
      investigation_name: pkg.package_name,
      investigation_id: pkg.package_id,
      mrp: pkg.mrp,
      rate: pkg.rate,
    })) || []),
  ];

  if (!receiptData) {
    return (
      <div style={{ padding: "40px", textAlign: "center", color: "#6b7280" }}>
        No receipt data available
      </div>
    );
  }

  const downloadPDF = async () => {
    try {
      setIsDownloading(true);

      const mobile = receiptData?.zone_obj?.mobile_number || "";
      const email = receiptData?.zone_obj?.email || "";
      const website = receiptData?.zone_obj?.website || "";
      const address = receiptData?.zone_obj?.address || "";
      const footerBarH = address ? 18 : 12;

      const headerEl = document.querySelector(".receipt-header-section");
      if (!headerEl) throw new Error("Header not found");
      const origHW = headerEl.style.width;
      headerEl.style.width = "794px";
      await new Promise((r) => setTimeout(r, 80));
      const headerCanvas = await html2canvas(headerEl, {
        scale: 2,
        useCORS: true,
        allowTaint: true,
        backgroundColor: null,
        windowWidth: 1000,
        scrollX: 0,
        scrollY: -headerEl.getBoundingClientRect().top,
        width: 794,
        height: headerEl.scrollHeight,
      });
      headerEl.style.width = origHW;
      const headerImgData = headerCanvas.toDataURL("image/png", 1.0);

      const downloadBtn = document.querySelector(".download-btn");
      const footerSection = document.querySelector(".receipt-footer-section");
      if (downloadBtn) downloadBtn.style.display = "none";
      if (footerSection) footerSection.style.display = "none";
      headerEl.style.display = "none";

      const receiptEl = document.querySelector(".receipt-inner-unique");
      if (!receiptEl) throw new Error("Receipt element not found");
      const origW = receiptEl.style.width;
      const origMW = receiptEl.style.minWidth;
      receiptEl.style.width = "794px";
      receiptEl.style.minWidth = "794px";
      await new Promise((r) => setTimeout(r, 150));
      window.scrollTo(0, 0);

      const bodyCanvas = await html2canvas(receiptEl, {
        scale: 2,
        useCORS: true,
        allowTaint: true,
        backgroundColor: "#ffffff",
        windowWidth: 1000,
        scrollX: 0,
        scrollY: -receiptEl.getBoundingClientRect().top,
        x: 0,
        y: 0,
        width: 794,
        height: receiptEl.scrollHeight,
      });

      receiptEl.style.width = origW;
      receiptEl.style.minWidth = origMW;
      headerEl.style.display = "";
      if (footerSection) footerSection.style.display = "block";
      if (downloadBtn) downloadBtn.style.display = "block";

      const pdf = new jsPDF("p", "mm", "a4");
      const pdfW = pdf.internal.pageSize.getWidth();
      const pdfH = pdf.internal.pageSize.getHeight();

      const headerH = (headerCanvas.height / headerCanvas.width) * pdfW;
      const bodyTotalH = (bodyCanvas.height / bodyCanvas.width) * pdfW;
      const slicePerPage = pdfH - headerH;
      const sliceLastPage = pdfH - headerH - footerBarH;
      const pxPerMM = bodyCanvas.width / pdfW;

      const drawHeader = () => {
        pdf.addImage(headerImgData, "PNG", 0, 0, pdfW, headerH);
      };

      const drawFooter = () => {
        const barY = pdfH - footerBarH;
        pdf.setFillColor(...BRAND_RGB);
        pdf.rect(0, barY, pdfW, footerBarH, "F");
        pdf.setDrawColor(255, 255, 255);
        pdf.setLineWidth(0.3);
        pdf.line(0, barY, pdfW, barY);

        const items = [];
        if (mobile) items.push({ l: "M", v: mobile });
        if (email) items.push({ l: "E", v: email });
        if (website) items.push({ l: "W", v: website });

        if (items.length > 0) {
          pdf.setFont("helvetica", "normal");
          pdf.setFontSize(8.5);
          const circleW = 5;
          pdf.setFont("helvetica", "bold");
          const sepW = pdf.getTextWidth("  |  ");
          pdf.setFont("helvetica", "normal");
          const totalW = items.reduce(
            (sum, it, i) =>
              sum +
              circleW +
              pdf.getTextWidth(it.v) +
              (i < items.length - 1 ? sepW : 0),
            0,
          );
          let curX = (pdfW - totalW) / 2;
          const rowY = barY + 7;
          items.forEach((it, i) => {
            pdf.setFillColor(255, 255, 255);
            pdf.circle(curX + 1.8, rowY - 1.2, 1.8, "F");
            pdf.setTextColor(...BRAND_RGB);
            pdf.setFont("helvetica", "bold");
            pdf.setFontSize(6);
            pdf.text(it.l, curX + 0.9, rowY - 0.3);
            pdf.setTextColor(255, 255, 255);
            pdf.setFont("helvetica", "normal");
            pdf.setFontSize(8.5);
            pdf.text(it.v, curX + 4.6, rowY);
            curX += circleW + pdf.getTextWidth(it.v);
            if (i < items.length - 1) {
              pdf.setFont("helvetica", "bold");
              pdf.text("  |  ", curX, rowY);
              curX += sepW;
            }
          });
        }

        if (address) {
          pdf.setFont("helvetica", "normal");
          pdf.setFontSize(8);
          pdf.setTextColor(255, 255, 255);
          const addrLine = pdf.splitTextToSize(
            `Addr: ${address}`,
            pdfW - 20,
          )[0];
          pdf.text(
            addrLine,
            (pdfW - pdf.getTextWidth(addrLine)) / 2,
            barY + 14,
          );
        }
        pdf.setTextColor(0, 0, 0);
      };

      let bodyOffsetMM = 0;
      let pageNum = 0;
      while (bodyOffsetMM < bodyTotalH) {
        if (pageNum > 0) pdf.addPage();
        pageNum++;
        const isLast = bodyOffsetMM + slicePerPage >= bodyTotalH;
        const sliceH = isLast
          ? Math.min(sliceLastPage, bodyTotalH - bodyOffsetMM)
          : slicePerPage;
        const srcY = Math.round(bodyOffsetMM * pxPerMM);
        const srcH = Math.round(sliceH * pxPerMM);
        const sliceCanvas = document.createElement("canvas");
        sliceCanvas.width = bodyCanvas.width;
        sliceCanvas.height = srcH;
        const ctx = sliceCanvas.getContext("2d");
        ctx.drawImage(
          bodyCanvas,
          0,
          srcY,
          bodyCanvas.width,
          srcH,
          0,
          0,
          bodyCanvas.width,
          srcH,
        );
        const sliceData = sliceCanvas.toDataURL("image/png", 1.0);
        drawHeader();
        pdf.addImage(sliceData, "PNG", 0, headerH, pdfW, sliceH);
        if (isLast) drawFooter();
        bodyOffsetMM += slicePerPage;
      }

      const currentDate = new Date().toISOString().split("T")[0];
      pdf.save(`EstimateReceipt_${currentDate}.pdf`);
    } catch (error) {
      console.error("Error generating PDF:", error);
      alert("Error generating PDF. Please try again.");
    } finally {
      setIsDownloading(false);
      const downloadBtn = document.querySelector(".download-btn");
      const footerSection = document.querySelector(".receipt-footer-section");
      const headerEl = document.querySelector(".receipt-header-section");
      if (downloadBtn) downloadBtn.style.display = "block";
      if (footerSection) footerSection.style.display = "block";
      if (headerEl) headerEl.style.display = "";
    }
  };

  const styles = {
    pageWrap: {
      background: "#f0f4f8",
      minHeight: "100vh",
      padding: "24px 16px",
      fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
    },
    card: {
      maxWidth: "794px",
      margin: "0 auto",
      background: "#ffffff",
      borderRadius: "12px",
      boxShadow: "0 4px 24px rgba(0,0,0,0.10)",
      overflow: "hidden",
    },
    header: { background: BRAND, padding: "0", position: "relative" },
    headerTop: {
      display: "flex",
      alignItems: "center",
      // justifyContent: "space-between",
      padding: "18px 28px 14px",
      gap: "12px",
      flexWrap: "wrap",
    },
    logoBox: {
      background: "#ffffff",
      borderRadius: "10px",
      padding: "8px 14px",
      display: "flex",
      alignItems: "center",
      boxShadow: "0 2px 8px rgba(0,0,0,0.12)",
    },
    headerCenter: { width: "325px", textAlign: "center" },
    headerTitle: {
      color: "#ffffff",
      fontSize: "20px",
      fontWeight: "800",
      letterSpacing: "2.5px",
      textTransform: "uppercase",
      margin: 0,
      textShadow: "0 1px 4px rgba(0,0,0,0.15)",
    },
    headerSubtitle: {
      color: "rgba(255,255,255,0.85)",
      fontSize: "11px",
      letterSpacing: "1px",
      marginTop: "3px",
    },
    badgePill: {
      // background: "rgba(255,255,255,0.22)",
      // border: "1px solid rgba(255,255,255,0.45)",
      color: "#fff",
      borderRadius: "20px",
      padding: "4px 14px",
      fontSize: "11px",
      fontWeight: "600",
      letterSpacing: "0.8px",
      whiteSpace: "nowrap",
    },
    headerDivider: {
      height: "4px",
      background: "linear-gradient(90deg, #f0a500, #ffcd57, #f0a500)",
    },
    body: { padding: "20px 28px" },
    sectionLabel: {
      fontSize: "10px",
      fontWeight: "700",
      color: BRAND,
      letterSpacing: "1.2px",
      textTransform: "uppercase",
      borderBottom: "2px solid #e5edf7",
      paddingBottom: "4px",
      marginBottom: "10px",
    },
    infoRow: {
      display: "flex",
      justifyContent: "space-between",
      padding: "5px 0",
      borderBottom: "1px dashed #e8edf2",
      fontSize: "13px",
      color: "#374151",
    },
    infoLabel: { color: "#6b7280", fontWeight: "500", minWidth: "140px" },
    infoValue: { fontWeight: "600", color: "#111827", textAlign: "right" },
    tableWrap: {
      overflowX: "auto",
      WebkitOverflowScrolling: "touch",
      borderRadius: "8px",
      border: "1px solid #dde5f0",
      marginBottom: "20px",
    },
    table: {
      width: "100%",
      minWidth: "500px",
      borderCollapse: "collapse",
      fontSize: "13px",
    },
    thead: { background: BRAND },
    th: {
      color: "#fff",
      fontWeight: "600",
      padding: "10px 12px",
      whiteSpace: "nowrap",
      letterSpacing: "0.4px",
      borderRight: "1px solid rgba(255,255,255,0.15)",
    },
    td: {
      padding: "9px 12px",
      borderBottom: "1px solid #e8edf5",
      verticalAlign: "top",
      color: "#374151",
    },
    totalsBox: {
      display: "flex",
      justifyContent: "flex-end",
      marginBottom: "16px",
    },
    totalsInner: {
      width: "100%",
      maxWidth: "340px",
      background: "#f7faff",
      borderRadius: "8px",
      border: "1px solid #dde5f0",
      overflow: "hidden",
    },
    totalRow: {
      display: "flex",
      justifyContent: "space-between",
      padding: "8px 14px",
      borderBottom: "1px solid #e8edf5",
      fontSize: "13.5px",
      color: "#374151",
    },
    totalRowFinal: {
      display: "flex",
      justifyContent: "space-between",
      padding: "10px 14px",
      background: BRAND,
      color: "#fff",
      fontWeight: "700",
      fontSize: "14px",
    },
    totalLabel: { color: "#6b7280" },
    totalValue: { fontWeight: "600" },
    noteBox: {
      background: "#f0f9ff",
      border: "1px solid #bae6fd",
      borderRadius: "8px",
      padding: "9px 14px",
      fontSize: "12px",
      color: "#0369a1",
      marginBottom: "16px",
    },
    signatureRow: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "flex-end",
      flexWrap: "wrap",
      gap: "12px",
      marginBottom: "16px",
    },
    signatureBox: {
      textAlign: "center",
      minWidth: "140px",
    },
    signatureLine: {
      borderTop: "1px dashed #9ca3af",
      width: "140px",
      marginBottom: "4px",
    },
    metaRow: {
      display: "flex",
      justifyContent: "space-between",
      flexWrap: "wrap",
      gap: "8px",
      fontSize: "12px",
      color: "#6b7280",
      marginBottom: "8px",
    },
    metaItem: { display: "flex", gap: "4px" },
    metaValue: { fontWeight: "600", color: "#374151" },
    footer: { background: BRAND, padding: "14px 28px 10px" },
    footerContactRow: {
      display: "flex",
      flexWrap: "wrap",
      justifyContent: "center",
      gap: "20px",
      marginBottom: "6px",
    },
    footerContactItem: {
      display: "flex",
      alignItems: "center",
      gap: "6px",
      color: "rgba(255,255,255,0.95)",
      fontSize: "12.5px",
      fontWeight: "500",
    },
    footerContactIcon: {
      width: "20px",
      height: "20px",
      background: "rgba(255,255,255,0.22)",
      borderRadius: "50%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontSize: "11px",
    },
    footerAddress: {
      textAlign: "center",
      color: "rgba(255,255,255,0.85)",
      fontSize: "11.5px",
      marginTop: "4px",
    },
    downloadWrap: {
      display: "flex",
      justifyContent: "center",
      padding: "18px 28px 24px",
    },
    downloadBtn: {
      background: isDownloading ? "#9ca3af" : BRAND,
      color: "#fff",
      border: "none",
      borderRadius: "8px",
      padding: "12px 40px",
      fontSize: "15px",
      fontWeight: "700",
      cursor: isDownloading ? "not-allowed" : "pointer",
      letterSpacing: "0.5px",
      boxShadow: isDownloading ? "none" : "0 4px 14px rgba(91,175,214,0.45)",
      transition: "all 0.2s",
      display: "flex",
      alignItems: "center",
      gap: "8px",
    },
  };

  return (
    <div style={styles.pageWrap}>
      <div style={styles.card}>
        <div className="receipt-inner-unique" style={{ minWidth: "300px" }}>
          {/* ── Header ── */}
          <div className="receipt-header-section" style={styles.header}>
            <div style={styles.headerTop}>
              <div style={styles.logoBox}>
                <img
                  src="../assets/img/medicity_logo.png"
                  alt="Medicity"
                  style={{
                    maxWidth: "200px",
                    maxHeight: "75px",
                    width: "auto",
                    height: "auto",
                    objectFit: "contain",
                    display: "block",
                  }}
                />
              </div>
              <div style={styles.headerCenter}>
                <p style={styles.headerTitle}>Estimate Receipt</p>
                <p style={styles.headerSubtitle}>OFFICIAL ESTIMATE DOCUMENT</p>
              </div>
              <div>
                <span style={styles.badgePill}></span>
              </div>
            </div>
            <div style={styles.headerDivider} />
          </div>

          {/* ── Body ── */}
          <div style={styles.body}>
            {/* Patient / Panel Info */}
            <p style={styles.sectionLabel}>Details</p>
            <div style={{ marginBottom: "20px" }}>
              {[
                ["Panel", receiptData?.company_name?.value || "N/A"],
                [
                  "Membership Card",
                  receiptData?.membership_card?.label || "N/A",
                ],
                ["Address", receiptData?.address || "—"],
              ].map(([label, value]) => (
                <div key={label} style={styles.infoRow}>
                  <span style={styles.infoLabel}>{label}</span>
                  <span style={styles.infoValue}>{value}</span>
                </div>
              ))}
            </div>

            {/* Services Table */}
            <p style={styles.sectionLabel}>Particulars</p>
            <div style={styles.tableWrap}>
              <table style={styles.table}>
                <thead style={styles.thead}>
                  <tr>
                    {["#", "Particulars", "Item Code", "Amount"].map((h) => (
                      <th key={h} style={styles.th}>
                        {h}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {allItems.map((item, index) => (
                    <tr
                      key={index}
                      style={index % 2 === 1 ? { background: "#f7faff" } : {}}
                    >
                      <td style={styles.td}>{index + 1}</td>
                      <td style={styles.td}>
                        {item?.investigation_name || "N/A"}
                      </td>
                      <td
                        style={{
                          ...styles.td,
                          color: "#6b7280",
                          fontSize: "12px",
                        }}
                      >
                        {item?.investigation_id || "—"}
                      </td>
                      <td
                        style={{
                          ...styles.td,
                          fontWeight: "700",
                          color: BRAND,
                        }}
                      >
                        {item?.mrp || "0"}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {/* Totals */}
            <div style={styles.totalsBox}>
              <div style={styles.totalsInner}>
                {[
                  ["Bill Amount", receiptData?.total_mrp || "0"],
                  ["Discount", receiptData?.calculated_cash_discount || "0"],
                  ["Total Gross", receiptData?.total_gross || "0"],
                ].map(([label, value]) => (
                  <div key={label} style={styles.totalRow}>
                    <span style={styles.totalLabel}>{label}</span>
                    <span style={styles.totalValue}>₹ {value}</span>
                  </div>
                ))}
                <div style={styles.totalRowFinal}>
                  <span>Net Amount</span>
                  <span>₹ {receiptData?.total_net || "0"}</span>
                </div>
              </div>
            </div>

            {/* Note */}
            <div style={styles.noteBox}>
              <strong>Note:</strong> Full Payment Before Investigation.
            </div>

            {/* Printed By + Signature */}
            <div style={styles.signatureRow}>
              <div style={styles.metaItem}>
                <span style={{ fontSize: "12px", color: "#6b7280" }}>
                  Printed By:
                </span>
                <span style={styles.metaValue}>
                  {receiptData?.printed_by || "—"}
                </span>
              </div>
              <div style={styles.signatureBox}>
                <div style={styles.signatureLine} />
                <span style={{ fontSize: "12px", color: "#6b7280" }}>
                  Signature
                </span>
              </div>
            </div>
          </div>

          {/* ── Screen-only footer ── */}
          <div className="receipt-footer-section" style={styles.footer}>
            <div style={styles.footerContactRow}>
              {receiptData?.zone_obj?.mobile_number && (
                <div style={styles.footerContactItem}>
                  <span style={styles.footerContactIcon}>📞</span>
                  <span>{receiptData.zone_obj.mobile_number}</span>
                </div>
              )}
              {receiptData?.zone_obj?.email && (
                <div style={styles.footerContactItem}>
                  <span style={styles.footerContactIcon}>✉</span>
                  <span>{receiptData.zone_obj.email}</span>
                </div>
              )}
              {receiptData?.zone_obj?.website && (
                <div style={styles.footerContactItem}>
                  <span style={styles.footerContactIcon}>🌐</span>
                  <span>{receiptData.zone_obj.website}</span>
                </div>
              )}
            </div>
            {receiptData?.zone_obj?.address && (
              <div style={styles.footerAddress}>
                📍 {receiptData.zone_obj.address}
              </div>
            )}
          </div>

          {/* ── Download button ── */}
          <div style={styles.downloadWrap}>
            <button
              className="download-btn"
              style={styles.downloadBtn}
              onClick={downloadPDF}
              disabled={isDownloading}
            >
              {isDownloading ? <>⏳ Generating PDF...</> : <>⬇️ Download PDF</>}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Receipt_B2C;
